import './trustedTypes'
import './embed'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import DocsPage from './DocsPage.jsx'
import AgbPage from './AgbPage.jsx'
import DatenschutzPage from './DatenschutzPage.jsx'
import NachpruefenPage from './NachpruefenPage.jsx'
import ErrorBoundary from './ErrorBoundary.jsx'
import './index.css'
import { applySystemTheme, subscribeToSystemTheme } from './theme'

const { pathname, search } = window.location;

// Redirects for login/checkout — blocked in robots.txt
if (pathname === '/login') {
  window.location.replace('https://datenputzer.de/sso?redirect=tresor');
} else if (pathname === '/checkout') {
  // Tresor vorerst nicht buchbar (24.10.26): alte Buchungslinks landen auf der Startseite.
  window.location.replace('/');
} else {
  const isDocsRoute = pathname === '/docs' || pathname === '/docs/' || pathname.startsWith('/docs/');
  const isAgbRoute = pathname === '/agb' || pathname === '/agb/';
  const isDatenschutzRoute = pathname === '/datenschutz' || pathname === '/datenschutz/';
  const isNachpruefenRoute = pathname === '/nachpruefen' || pathname === '/nachpruefen/';
  const isPublicStandalone = isDocsRoute || isAgbRoute || isDatenschutzRoute || isNachpruefenRoute;

  if (isPublicStandalone) {
    applySystemTheme();
    subscribeToSystemTheme({ forceSystem: true });
  } else {
    applySystemTheme();
    subscribeToSystemTheme();
  }

  let Page = App;
  if (isDocsRoute) Page = DocsPage;
  else if (isAgbRoute) Page = AgbPage;
  else if (isDatenschutzRoute) Page = DatenschutzPage;
  else if (isNachpruefenRoute) Page = NachpruefenPage;

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ErrorBoundary>
        <Page />
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
